import { render, staticRenderFns } from "./MicrobiologyProgressBar.vue?vue&type=template&id=d63859fe&scoped=true"
import script from "./MicrobiologyProgressBar.vue?vue&type=script&lang=js"
export * from "./MicrobiologyProgressBar.vue?vue&type=script&lang=js"
import style0 from "./MicrobiologyProgressBar.vue?vue&type=style&index=0&id=d63859fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d63859fe",
  null
  
)

export default component.exports